import * as GTM from './gtm'

export function addToBasket(basket_id, total, items, prodGA, userData) {
	GTM.addToBasket(prodGA, userData)
	// cart updates
	GTM.cartInsight(basket_id, total, items)
}

export function remFromBasket(basket_id, total, items, prodGA) {
	GTM.remFromBasket(prodGA)
	// cart updates
	GTM.cartInsight(basket_id, total, items)
}

export function storePurchase(
	basket_id,
	items,
	order_id,
	total,
	voucher_code,
	email,
	user_id = undefined,
	source = 'Store',
	enhanced_data
) {
	GTM.cartInsight(basket_id, total, items)
	GTM.purchaseStore(items, order_id, total, voucher_code, user_id, source, enhanced_data)
	//if (voucher_code !== '' && voucher_code !== undefined) discountCode(voucher_code)
}

export function viewItemMain(product, userData) {
	GTM.ViewItem(product, userData)
}

export function ViewItemListMain(products, name = undefined) {
	GTM.ViewItemList(products, name)
	const promos = []
	products.map((product) => {
		if (product.on_offer) {
			promos.push({
				id: product.offer.promo_event_id,
				name: product.offer.promo_event_title,
				item: product,
			})
		}
	})
	var uniquePromos = []
	promos.forEach(function (item) {
		var i = uniquePromos.findIndex((x) => x.name == item.name)
		if (i <= -1) {
			uniquePromos.push({ id: item.id, name: item.name, items: [item.item] })
		} else {
			uniquePromos[i].items.push(item.item)
		}
	})
	if (uniquePromos.length > 0) {
		GTM.viewPromo(uniquePromos)
	}
}

export function beginCheckout(products) {
	//GTM.beginCheckout(products)
}

export function Identify(email) {
	GTM.OmetriaIdentify(email)
	GTM.ImpactIdentify(null, email)
}

export function cartInsight(basket_id, total, items) {
	GTM.cartInsight(basket_id, total, items)
}
